import React, { useEffect, useState } from 'react';
import { Redirect, Route, RouteProps, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppStore, RequestStatus, UserStatus } from '@akademiasaas/shared';
import { Spin } from 'antd';

/**
 * Ile czekamy na dokument użytkownika w Firestore, gdy użytkownik jest już zalogowany w Firebase.
 * Po rejestracji dokument zapisuje się z opóźnieniem (T-326); `onSnapshot` dostarczy go sam.
 */
export const USER_DOCUMENT_WAIT_MS = 20_000;

const ProtectedRoute = ({ component: Component, ...rest }: RouteProps) => {
  const {
    data: user,
    status,
    detailsStatus,
    details,
  } = useSelector((store: AppStore) => store.user);
  const history = useHistory();
  const continuePath = history.location.pathname + history.location.search;

  const isAwaitingUserDocument =
    Boolean(user) && details === null && detailsStatus === RequestStatus.SUCCESS;
  const [documentWaitTimedOut, setDocumentWaitTimedOut] = useState(false);

  useEffect(() => {
    if (!isAwaitingUserDocument) {
      setDocumentWaitTimedOut(false);

      return undefined;
    }
    const timer = setTimeout(() => setDocumentWaitTimedOut(true), USER_DOCUMENT_WAIT_MS);

    return () => clearTimeout(timer);
  }, [isAwaitingUserDocument]);

  if (!Component) {
    throw new Error('Component is missing');
  }
  const authPath = `/auth/login?continue=${encodeURIComponent(continuePath)}`;

  const isLoggingIn =
    status === UserStatus.LOGGING_IN ||
    (detailsStatus === null && status === UserStatus.IS_LOGGED) ||
    detailsStatus === RequestStatus.FETCHING ||
    (isAwaitingUserDocument && !documentWaitTimedOut);

  if (isLoggingIn) {
    return (
      <div
        style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        return user && details ? <Component {...props} /> : <Redirect to={authPath} />;
      }}
    />
  );
};
export default ProtectedRoute;
